<template>
    <div id="app_cancelPop" @keydown.esc="on_key_esc" @keydown.enter="on_key_enter">
        <div class="app_cancel_in">
            <div v-if="attr.title" class="titlemsg">
                <h1 v-html="attr.title">
                </h1>
                <p id="msg" v-html="attr.msg">
                </p>
            </div>
            <p v-else v-html="attr.msg">
            </p>
            <div :class="[dbuttons.length > 1 ? 'multi_buttons' : 'single_buttons']">
                <v-btn v-for="(button, idx) in dbuttons" :key="idx" :class="button.id" @click="on_button_click(button.id)">
                    {{button.buttext}}
                </v-btn>
            </div>
        </div>
        <div id='keyeventreceiver'>
            <input id="keyeventreceiver" ref="keyeventreceiver" type="text" @keydown.esc="on_key_esc"/>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        attr : Object,
    },

    create() {

    },

    mounted()
    {
        var pbuttons = this.attr.buttons;
        var dbuttons = [];
        this.dmsg = this.attr.msg;

        ["no", "cancel", "yes", "ok"].forEach((key)=>{
            if(pbuttons[key] != undefined)
            {
                var but = pbuttons[key];
                if(but == "")
                    switch(key)
                    {
                        case "yes" : but = "YES"; break;
                        case "no" : but = "NO"; break;
                        case "cancel" : but = "CANCEL"; break;
                        case "ok" : but = "OK"; break;
                    }
                dbuttons.push({id : key, buttext : but});
            }
            else 
            {
                //console.log(key, pbuttons[key]);
            }
        });
        
        this.dbuttons = dbuttons;
        this.$refs.keyeventreceiver.focus();

    },

    data() {
        return {
            dbuttons : [],
            dmsg : '',
        }
    },
    methods : {
        on_button_click(key)
        {
            this.$ModalManager.close(this, {result : key})
        },
        on_key_esc()
        {
            this.$ModalManager.close(this, "nothing");
        },
        on_key_enter() 
        {
            console.log(this.dbuttons)
            this.$ModalManager.close(this, "nothing");
        }
    }
}
</script>

<style scoped>

#app_cancelPop {
    width: 500px;
    background-color: #fff;
    border-radius: 15px;
    padding: 55px 68px 30px 68px;
    box-sizing: border-box;
    color: #6c6c6c;
    text-align: center;
}
.app_cancel_in p {
    font-weight: bold;
    color: rgb(145, 4, 87);
    margin-bottom: 55px;
    font-size: 18px;
}

h1 {
    font-size: 18px;
    font-weight: bold;
    color: rgb(145, 4, 87);
    margin-bottom: 11px;
}
div.titlemsg > p {
    font-weight : normal;
    font-size: 16px;
    margin-bottom: 30px;
}

.app_cancel_in > div {
    width: 364px;
    height: 40px;
    margin: 0 auto;
    display: flex;
}

.app_cancel_in > div.titlemsg {
    display: inline;
}

.single_buttons {
    justify-content: center;
}
.multi_buttons {
    justify-content: space-between;
}

button {
    width: 170px;
    border-radius: 50px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    border: none;
}

button.no, button.cancel {
    background-color: #9c9c9c;
}
button.yes, button.ok {
    background-color: rgb(145, 4, 87);
}

div#keyeventreceiver {
    position: absolute;
    width:0px;
    height: 0px;
    /* top : 5000px; */
}

input#keyeventreceiver {
    /* visibility: hidden; */
}
</style>